import React from 'react'

const Fifty_eight = () => {
    return (
        <div className='container'>
            <h1>Find the Sum of  Natural Numbers using Recursion</h1>
            <div className='containers'>
            The positive numbers 1, 2, 3... are known as natural numbers. 
            The program below takes a positive integer from the user and calculates 
            the sum up to the given number. <br />
            </div>
            <div className='containers'>
           <code className='library'>#include</code>  &lt;stdio.h &gt;<br/>
           <code className='keywords'>int </code>addNumbers(int n);<br/>
           <code className='keywords'>int </code>main()  &#123;<br/>
           <code className='keywords'>  int </code>num;<br/>
           <code className='library'> printf</code>("Enter a positive integer: ");<br/>
           <code className='keywords'>scanf</code>("%d", &num);<br/>
           <code className='keywords'>printf</code>("Sum = %d", addNumbers(num));<br/>
           <code className='library'>return</code> 0;<br/>
 &#125;<br/>   

 <code className='keywords'>int</code> addNumbers(int n)  &#123;<br/>
 <code className='keywords'>  if</code> (n != 0)
        return n + addNumbers(n - 1);<br/>
        <code className='keywords'> else</code>
        <code className='library'>   return</code> n;<br/>
&#125;<br/>
            </div>
        </div>
    )
}

export default Fifty_eight
